import _classnames from 'clsx';
import PropTypes from 'prop-types';

function HorizontalStackedBarChart({
  activeIndex,
  data,
  handleMouseEnter,
  handleMouseLeave,
  hasBackdrop,
  isLoading,
}) {
  const total = data.reduce((result, current) => result + current.number, 0);
  const minWidth = 1 / data.length;

  return (
    <div
      className={_classnames('HorizontalStackedBarChart', {
        'HorizontalStackedBarChart--has-backdrop': hasBackdrop || total === 0,
        'HorizontalStackedBarChart--loading': isLoading,
      })}
    >
      {!isLoading &&
        data.map(
          (datum, i) =>
            datum.number !== 0 &&
            datum.number !== null && (
              <div
                className={_classnames('HorizontalStackedBarChart__bar', {
                  'HorizontalStackedBarChart__bar--active': activeIndex === i,
                })}
                key={`HorizontalStackedBarChartBar-${datum.number}-${datum.color}`}
                onMouseEnter={() => handleMouseEnter(i)}
                onMouseLeave={handleMouseLeave}
                style={{
                  background: datum.color,
                  width: `${Math.floor((datum.number / total) * 100) || minWidth}%`,
                }}
              />
            )
        )}
    </div>
  );
}

HorizontalStackedBarChart.propTypes = {
  activeIndex: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleMouseEnter: PropTypes.func,
  handleMouseLeave: PropTypes.func,
  hasBackdrop: PropTypes.bool,
  isLoading: PropTypes.bool,
};

HorizontalStackedBarChart.defaultProps = {
  hasBackdrop: false,
  isLoading: false,
  handleMouseEnter: () => {},
  handleMouseLeave: () => {},
};

export default HorizontalStackedBarChart;
